import { Renderer } from '@unseenco/taxi';
import { isDEVMODE, viewStorage } from '../_globals'
import MobileSwiper from '../modules/mobile-swiper'
import WknSwiper from '../modules/wkn-swiper'
import { accompanimentSwiperOptions } from '../modules/accompaniment-swiper-options'
import Accordions from '../modules/accordions'
import Countdown from '../modules/countdown'

export default class PageGutenberg extends Renderer {
  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  }

  onEnter() {
    this.DOM = {
      presentationCardsSwipers: viewStorage.current.querySelectorAll('.PresentationCards .swiper.--mobile'),
      relatedProfilesSwipers: viewStorage.current.querySelectorAll('.RelatedProfiles .swiper'),
      relatedQuestions: viewStorage.current.querySelectorAll('.RelatedQuestions'),
      accompanimentSwipers: viewStorage.current.querySelectorAll('.Accompaniment .swiper'),
      countdown: viewStorage.current.querySelector('.Countdown'),
      // fix accordeons-blocs-gutenberg — les nouveaux blocs rendent leurs items via .Accordion mais
      // n'etaient cables par aucun renderer (PageGutenberg ne ciblait que l'ancien bloc .RelatedQuestions)
      blockAccordions: viewStorage.current.querySelectorAll('.FaqRelation, .ListeAccordion'),
      // Bloc "points forts" : onglets a gauche -> defilement vertical des cartes a droite
      garantiesTabsBlocks: viewStorage.current.querySelectorAll('.AccordionGaranties'),
      // fix sliders-blocs-gutenberg — les nouveaux blocs slider rendent un .swiper mais n'etaient
      // instancies par aucun renderer (PageGutenberg ne ciblait que les anciens swipers)
      blockSliders: viewStorage.current.querySelectorAll('.SliderAvantages .swiper, .SliderCards .swiper, .SliderEtapes .swiper, .TableauGaranties .swiper')
    }

    this.init()
  }

  init() {
    const {
      presentationCardsSwipers = null,
      relatedProfilesSwipers = null,
      relatedQuestions = null,
      accompanimentSwipers = null,
      countdown = null,
      blockAccordions = null,
      garantiesTabsBlocks = null,
      blockSliders = null
    } = this.DOM

    if (presentationCardsSwipers && presentationCardsSwipers.length) {
      this.presentationSwipers = []

      presentationCardsSwipers.forEach(swiper => this.presentationSwipers.push(new MobileSwiper(swiper)))
    }

    if (relatedProfilesSwipers && relatedProfilesSwipers.length) {
      this.relatedProfilesSwipers = []

      relatedProfilesSwipers.forEach(swiper => this.relatedProfilesSwipers.push(new WknSwiper(swiper, { slidesPerView: 'auto', centerInsufficientSlides: true })))
    }

    if (relatedQuestions && relatedQuestions.length) {
      this.faqs = []

      relatedQuestions.forEach(questions => this.faqs.push(new Accordions(questions)))
    }

    if (accompanimentSwipers && accompanimentSwipers.length) {
      this.accompanimentSwipers = []

      accompanimentSwipers.forEach(swiper => this.accompanimentSwipers.push(new WknSwiper(swiper, accompanimentSwiperOptions)))
    }

    if (countdown) this.countdownModule = new Countdown(countdown)

    // fix accordeons-blocs-gutenberg — 1 instance Accordions par bloc a accordeon (scope = wrapper du bloc),
    // cable les .Accordion .head des nouveaux blocs FaqRelation / ListeAccordion / AccordionGaranties
    if (blockAccordions && blockAccordions.length) {
      this.blockAccordions = []

      blockAccordions.forEach(block => this.blockAccordions.push(new Accordions(block)))
    }

    // Bloc "points forts" : clic sur un onglet -> pastille active + defilement vertical des cartes
    if (garantiesTabsBlocks && garantiesTabsBlocks.length) {
      this.garantiesTabsHandlers = []

      garantiesTabsBlocks.forEach(block => {
        const tabs = [...block.querySelectorAll('.AccordionGaranties__tab')]
        const cardsTrack = block.querySelector('.AccordionGaranties__cards')

        if (!tabs.length || !cardsTrack) return

        const onClick = e => {
          const tab = e.currentTarget
          const index = parseInt(tab.dataset.index, 10) || 0
          const cards = [...cardsTrack.children]

          tabs.forEach(t => t.classList.toggle('--active', t === tab))
          // Mobile : la carte active est affichée via CSS (pas de translateY)
          cards.forEach((card, i) => card.classList.toggle('--active', i === index))

          // Decalage = position naturelle de la carte cible dans la pile
          const offset = cards[index] ? cards[index].offsetTop : 0
          cardsTrack.style.transform = `translateY(${-offset}px)`
        }

        // Etat initial : premiere carte active (affichage mobile)
        const cards = [...cardsTrack.children]
        cards.forEach((card, i) => card.classList.toggle('--active', i === 0))

        tabs.forEach(tab => tab.addEventListener('click', onClick))
        this.garantiesTabsHandlers.push({ tabs, onClick })
      })
    }

    // fix sliders-blocs-gutenberg — 1 instance WknSwiper par slider (navigation prev/next auto-detectee),
    // slidesPerView auto : la largeur des slides vient du CSS du bloc (ex. SliderAvantages : 390px)
    if (blockSliders && blockSliders.length) {
      this.blockSliders = []

      // Ref maquette : gap 30 (SliderAvantages) ou 20 (SliderEtapes, SliderCards)
      // slidesOffsetAfter : en fin de course, la DERNIERE carte se cale a gauche comme les autres
      // (sinon Swiper borne sur le bord droit et rogne la carte de gauche)
      blockSliders.forEach(slider => {
        // TableauGaranties : gouttiere 15 entre colonnes (ref maquette), inchangee en slider
        const spaceBetween = slider.closest('.TableauGaranties')
          ? 15
          : (slider.closest('.SliderEtapes') || slider.closest('.SliderCards') ? 20 : 30)

        // TableauGaranties : pas d'offset de fin. C'est un tableau comparatif, pas une pile de
        // cartes — a 6 formules, se terminer sur UNE colonne suivie de ~930px de blanc reproduit
        // exactement le defaut signale au point 3. La fin de course cale donc la derniere colonne
        // sur le bord droit, en gardant 3 colonnes cote a cote.
        const isTableau = !!slider.closest('.TableauGaranties')

        const computeOffsetAfter = () => {
          if (isTableau) return 0
          const slides = [...slider.querySelectorAll('.swiper-slide')]
          if (!slides.length) return 0
          const rowWidth = slides.reduce((w, s) => w + s.offsetWidth, 0) + spaceBetween * (slides.length - 1)
          if (rowWidth <= slider.offsetWidth) return 0 // tout tient : pas de scroll, pas d'offset
          return Math.max(0, slider.offsetWidth - slides[slides.length - 1].offsetWidth)
        }

        this.blockSliders.push(new WknSwiper(slider, {
          slidesPerView: 'auto',
          spaceBetween,
          // fix (25/08) : a 2 ou 3 cartes, la rangee est plus etroite que le conteneur —
          // Swiper la calait a gauche et laissait un vide a droite. centerInsufficientSlides
          // recentre la rangee tant qu'elle tient entierement (au-dela, comportement inchange).
          centerInsufficientSlides: true,
          slidesOffsetAfter: computeOffsetAfter(),
          on: {
            resize(s) {
              s.params.slidesOffsetAfter = computeOffsetAfter()
              s.update()
            }
          }
        }))
      })
    }
  }

  onLeaveCompleted() {
    this.presentationSwipers && this.presentationSwipers.length && this.presentationSwipers.forEach(swiper => swiper.destroy())
    this.relatedProfilesSwipers && this.relatedProfilesSwipers.length && this.relatedProfilesSwipers.forEach(swiper => swiper.destroy())
    this.faqs && this.faqs.length && this.faqs.forEach(faq => faq.destroy())
    this.accompanimentSwipers && this.accompanimentSwipers.length && this.accompanimentSwipers.forEach(swiper => swiper.destroy())
    this.countdownModule && this.countdownModule.destroy()
    this.blockAccordions && this.blockAccordions.length && this.blockAccordions.forEach(accordions => accordions.destroy())
    this.garantiesTabsHandlers && this.garantiesTabsHandlers.length && this.garantiesTabsHandlers.forEach(({ tabs, onClick }) => tabs.forEach(tab => tab.removeEventListener('click', onClick)))
    this.blockSliders && this.blockSliders.length && this.blockSliders.forEach(slider => slider.destroy())
  }
}
